export enum Dynamic {
  Constant = 'CONSTANT',
  Rising = 'RISING',
}
